import windows from "../../Img/windows.svg";
import apple from "../../Img/Apple.svg";
import linux from "../../Img/linux.svg";
import threedo from "../../Img/3do.svg";
import ios from "../../Img/ios.svg";
import android from "../../Img/android.svg";
import atari from "../../Img/atari.svg";
import commodore from "../../Img/commodore.svg";
import sega from "../../Img/sega.svg";
import neogeo from "../../Img/neogeo.svg";
import web from "../../Img/web.svg";
import playstation from "../../Img/playstation.svg";
import xbox from "../../Img/xbox.svg";
import switchnintendo from "../../Img/switchnintendo.svg";

export const PLATFORM_ICON_CONFIG = {
  pc: windows,
  playstation: playstation,
  mac: apple,
  xbox: xbox,
  nintendo: switchnintendo,
  linux: linux,
  "3do": threedo,
  ios: ios,
  android: android,
  atari: atari,
  "commodore-amiga": commodore,
  sega: sega,
  "neo-geo": neogeo,
  web: web,
};
